
import React from 'react'
import { Helmet } from 'react-helmet';
import { useMediaQuery } from 'react-responsive'
import { useNavigate, Link } from "react-router-dom"
import Button from '../../components/Button'
import Return from '../../components/Forum/Return'
import CommentIcon from '../../images/comment.svg'
import LikeIcon from '../../images/like.svg'

export default function Post105() {

  const tabletBreakpoint = useMediaQuery({ query: '(min-width: 768px)' })

  const navigate = useNavigate()

  React.useEffect(() => { 
    window.scrollTo(0, 0)
  }, [])


  return (

    <div className="top-margin-s">

      <Helmet>
        <title>Oi pessoal. Descobri a pressão alta a pouco tempo, e ainda estou aprendendo oque posso e não posso fazer. Vocês poderiam me explicar um pouco como deve ser a alimentação para quem tem essa doença?</title>
        <meta 
          name="description" 
          content="Oi pessoal. Descobri a pressão alta a pouco tempo, e ainda estou aprendendo oque posso e não posso fazer. Vocês poderiam me explicar um pouco como deve ser a alimentação para quem tem essa doença?"/>
      </Helmet>

      <div className={(tabletBreakpoint) ? 
        "container-simple-tablet" : "container-simple"}>
        <div className="top-margin-s bottom-margin-s">
          <Return to='/forum' />
        </div>
        <div className="bottom-margin-s">
          <p className="secondary-text bottom-margin-xs">
            Larissa Maia &#183; 15/08/2024
          </p>
        </div>


        <p className="body content bottom-padding-s">
            Oi pessoal. Descobri a pressão alta a pouco tempo, e ainda estou aprendendo oque posso e não posso fazer. Vocês poderiam me explicar um pouco como deve ser a alimentação para quem tem essa doença?
        </p>


        <div className="post-stats bottom-padding-xs">
          <button onClick={()=>{navigate('/forum/105')}} className="svg-btn">
            <div className="post-useful-info">
              <div> 
               <img src={LikeIcon} alt="Button indicating if you found this useful" />
              </div>
              <p className="secondary-text">
                  4 pessoas acharam útil
              </p>
            </div>
          </button>

          <div className="post-useful-info"> 
            <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
            <p className="secondary-text">
              1 comentário
            </p>
          </div> 
        </div>
        <div className="top-padding-xs">

              <div className="comment-background comment">
                <p className="body comment-fixed">
                  Oi, Larissa!<br/><br/>Seja bem-vinda ao grupo! Entendo que pode ser um pouco assustador receber esse diagnóstico, mas com algumas mudanças na alimentação e no estilo de vida, você pode conseguir controlar a pressão alta.<br/><br/>Aqui vão algumas dicas básicas de alimentação para quem tem pressão alta:<br/><br/>1. **Reduza o sal:** O sal é um grande vilão da pressão alta. Tente evitar alimentos muito salgados como embutidos (presunto, salame), enlatados e fast foods. Prefira temperos naturais como alho, cebola, ervas e limão para dar sabor aos pratos.<br/><br/>2. **Consuma mais frutas e vegetais:** Eles são ricos em potássio, que ajuda a equilibrar o efeito do sódio no seu organismo. Tente incluir uma variedade de cores no seu prato – quanto mais colorido, melhor!<br/><br/>3. **Escolha grãos integrais:** Arroz integral, aveia e pão integral são melhores opções do que os refinados, pois ajudam a manter os níveis de açúcar no sangue estáveis e são ricos em fibras.<br/><br/>4. **Opte por proteínas magras:** Carnes magras, peixes, frango sem pele, leguminosas (feijões, lentilhas) e tofu são ótimas opções. Evite carnes gordurosas e frituras.<br/><br/>5. **Modere o consumo de álcool:** O álcool pode aumentar a pressão arterial, então é melhor consumir com moderação, se for o caso.<br/><br/>6. **Fique de olho nas gorduras:** Prefira gorduras boas, como azeite de oliva, abacate, castanhas e sementes. Evite gorduras trans e saturadas, presentes em frituras e alimentos industrializados.<br/><br/>Além dessas dicas, lembre-se de seguir as orientações do seu médico e, se possível, consulte uma nutricionista para obter um plano alimentar personalizado.<br/><br/>Espero que essas dicas te ajudem! Fique firme e saiba que estamos aqui para apoiar. Qualquer coisa, estamos por aqui.<br/><br/>Abraços,<br/>Florence
                </p>
              </div>

              <div className="post-stats">
                <div className="bottom-margin-s">
                  <p className="secondary-text bottom-margin-xs">
                    Florence Health &#183; 15/08/2024
                  </p>
                </div>
              </div>


          <Button type="primary bottom-margin-s" onClick={()=>{navigate('/forum/105')}}>Comentar</Button>
        </div>

        <div className="top-padding-s">
          <p className="heading4 bottom-padding-xs bottom-border">Postagens Relacionadas</p>


              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Marlene Techini &#183; 08/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/48-cancer" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal, tenho 31 anos e não fumo.<br/>Descobri que estou com com câncer de pulmão e estou assustada.<br/>Alguém com câncer no pulmão poderia compartilhar como está sendo?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/48')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            1 pessoa achou útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    T. Estudante &#183; 24/07/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/11-diabetes" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Diabetes: Minha experiência medindo glicose em casa  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Após o diagnóstico com diabetes, a melhor coisa que fiz foi comprar um medidor de glicose, aprender a usar e medir todos os dias. Recomendo para todos sempre. Acredito que esse seja o melhor jeito para aprender a controlar a diabetes.<br/><br/>Dica: para mim, o melhor lugar para espetar o dedo é nos lados das pontas, perto das unhas (mas não muito perto).<br/><br/>Teste sua glicose com a maior frequência que você conseguir: Isso é especialmente importante no início, quando você está aprendendo como seu corpo reage às diferentes comidas e os exercícios físicos que você faz.<br/><br/>A maioria das pessoas gosta de medir quando levantam de manhã. Isso é chamado de teste de jejum, e dá uma indicação de quão bom foi o seu controle no dia anterior.<br/><br/>Outros horários comuns para testar:<br/><br/>1) Uma ou duas horas depois de uma refeição: o resultado mostra quão alto a sua glicose sobre quando você come aquelas comidas em particular. Toda a comida que você põe na boca influencia o nível de glicose, e é importante entender como é essa influência.<br/><br/>2) Antes da próxima refeição: o resultado mostra se a subida da glicose da refeição anterior já desceu para o patamar normal antes da próxima refeição.<br/><br/>3) Antes e depois de exercício.<br/><br/>4) Na hora de dormir.<br/><br/>5) A qualquer momento que você acha que tem algo de errado.<br/><br/>É legal rotacionar os horários de teste ao longo dos dias para conseguir mais informações.<br/><br/>Após mais ou menos um ano com esse treinamento intensivo, eu tinha um bom conhecimento de como meu corpo reagia as várias coisas, e pude reduzir a frequência das medições.<br/><br/>Por fim, registre e guarde os resultados das medições (no caderno, no computador ou no excel, onde você quiser), e também tenha cópia de todos os seus exames. Ter esses registros vai fazer com que você estude mais para entendê-los e vai te ajudar a saber como está a sua condição ao longo do tempo. No longo prazo, esse registros valem ouro!<br/><br/>Espero que isso possa ajudar quem está começando sua jornada com diabetes!<br/>
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/11')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Tami Costa &#183; 06/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/25-diabetes" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Dúvida hipoglicemia:  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Quanto de glicemia é considerado hipoglicemia? Hoje estava com 75, mas não estava sentindo nada
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/25')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Claudia Coimbra &#183; 13/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/83-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal. Preciso de ajuda. Quando tem moleza no corpo e vontade de dormir o dia todo é porque a diabetes está baixa?<br/>Meu marido tem diabates, e as vezes ele dorme o dia todo.
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/83')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            5 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Carlos Frantz &#183; 18/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/126-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    O que vocês sabem sobre neuropatia? Estou de cadeira de rodas por isso
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/126')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            3 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>


        </div>

      </div>
    </div>
  )
}
